import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { Row, Col, Spin } from 'antd';
import BarChartComponent from '../Charts/BarChartComponent';
import PieChartComponent from '../Charts/PieChartComponent';

const CampaignAnalytics = ({ onDrillDown }) => {
    const { t } = useTranslation();
    const { campaignAnalytics, loadingCampaign } = useSelector((state) => state.analytics);

    if (loadingCampaign) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div>
            <Row gutter={[16, 16]}>
                {/* Campaign Code Performance */}
                <Col span={12}>
                    <BarChartComponent
                        data={campaignAnalytics?.byCampaignCode || []}
                        xAxisKey="label"
                        yAxisKey="count"
                        title={t('analytics.campaignCodePerformance')}
                        color="#3b82f6"
                        loading={loadingCampaign}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = campaignAnalytics?.byCampaignCode?.find(d => d.label === data.activeLabel);
                                onDrillDown(`${t('analytics.campaignCodePerformance')} - ${data.activeLabel}`, "leads", { key: data.activeLabel }, item?.records);
                            }
                        }}
                    />
                </Col>

                {/* Lead Source Distribution */}
                <Col span={12}>
                    <PieChartComponent
                        data={campaignAnalytics?.byLeadSource || []}
                        dataKey="count"
                        nameKey="sourceName"
                        title={t('analytics.leadSourceDistribution')}
                        loading={loadingCampaign}
                        onClick={(data) => {
                            const item = campaignAnalytics?.byLeadSource?.find(d => d.sourceName === data.name);
                            onDrillDown(`${t('analytics.leadSourceDistribution')} - ${data.name}`, "leads", { key: data.name }, item?.records);
                        }}
                    />
                </Col>

                {/* Record Count by Campaign */}
                <Col span={24}>
                    <BarChartComponent
                        data={campaignAnalytics?.recordCountByCampaign || []}
                        xAxisKey="label"
                        yAxisKey="count"
                        title={t('analytics.recordCountByCampaign')}
                        color="#10b981"
                        loading={loadingCampaign}
                        height={400}
                        onClick={(data) => {
                            if (data && data.activeLabel) {
                                const item = campaignAnalytics?.recordCountByCampaign?.find(d => d.label === data.activeLabel);
                                onDrillDown(`${t('analytics.recordCountByCampaign')} - ${data.activeLabel}`, "leads", { key: data.activeLabel }, item?.records);
                            }
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default CampaignAnalytics;
